/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromPurchase from 'app/shared/store/actions/purchase.action';
import { Constants } from '@shared/models/constants.model';
export interface PurchaseState {
  name: string;
  options: any;
  total: number;
  subtotal: number;
  processingFee: number;
  coupon: any;
  couponCode: string;
  discount: number;
}

export const initialState = {
  name: null,
  options: [],
  total: 0,
  subtotal: 0,
  processingFee: 0,
  coupon: null,
  couponCode: null,
  discount: null,
};

export function reducer(state = initialState, action: fromPurchase.PurchaseAction): PurchaseState {
  switch (action.type) {
    case fromPurchase.RESET_PLAN: {
      return { ...initialState };
    }

    case fromPurchase.SET_PLAN: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case fromPurchase.ADD_ITEMS: {
      return {
        ...state,
        name: state.name || Constants.PLAN_TYPE.ONE_EVENT,
        options: [...state.options, ...action.payload],
      };
    }

    case fromPurchase.SET_ITEMS: {
      return {
        ...state,
        options: [...action.payload],
      };
    }

    case fromPurchase.REMOVE_ITEM_AT_INDEX: {
      if (action.payload >= 0) {
        return {
          ...state,
          options: [...state.options.slice(0, action.payload), ...state.options.slice(action.payload + 1)],
        };
      }

      return state;
    }

    case fromPurchase.SET_PRICE: {
      return {
        ...state,
        subtotal: action.payload.subtotal,
        processingFee: action.payload.processingFee,
        total: action.payload.subtotal + action.payload.processingFee,
      };
    }

    case fromPurchase.SET_COUPON: {
      return {
        ...state,
        coupon: action.payload.coupon,
        couponCode: action.payload.coupon.code,
      };
    }

    case fromPurchase.CLEAR_COUPON: {
      return {
        ...state,
        coupon: initialState.coupon,
        couponCode: initialState.couponCode,
      };
    }

    case fromPurchase.SET_INVITEE: {
      const updatedItem = state.options[action.payload.index];
      return {
        ...state,
        options: [
          ...state.options.slice(0, action.payload.index),
          {
            ...updatedItem,
            invitee: {
              ...updatedItem.invitee,
              ...action.payload.invitee,
            },
          },
          ...state.options.slice(action.payload.index + 1),
        ],
      };
    }

    case fromPurchase.SET_ITEM_SPORT: {
      const updatedItem = state.options[action.payload.index];
      return {
        ...state,
        options: [
          ...state.options.slice(0, action.payload.index),
          { ...updatedItem, sportId: action.payload.sportId },
          ...state.options.slice(action.payload.index + 1),
        ],
      };
    }
  }
  return state;
}
